import uuid from "../model/uuid";
import { AxiosResponse } from 'axios';

import * as apiClient from "../infrastructure/apiClient/apiClient";
import ApiPromise from "../infrastructure/apiClient/ApiPromise";

const downloadStatisticsFile = (contestId: uuid): ApiPromise<{statisticsFileUrl: string}> => {
    return ApiPromise.fromAxiosPromise(
        apiClient.contestsId.patch(contestId, {generateStatisticsDocument: {}})
    )
        .onSuccess((response: AxiosResponse) => response.data)
}

export default downloadStatisticsFile;
